import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";

export default function Panel_E({ data, setData, onUploadDialog, uploadPic, disabledPage }) {
    useEffect(() => {
        // console.log('data ',data);
    }, [data]); //searchData

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };
    const display_mode = () => {
        return data.displayMode === "Y" ? true : false;
    };

    const testingResulOptions = [
        { label: "ผ่าน", value: "Y" },
        { label: "แก้ไข", value: "N" },

    ];

    const fieldTestingResultOptions = [
        { label: "ถูกต้อง", value: "Y" },
        { label: "แก้ไข", value: "N" },

    ];

    const scheduleInformResultOptions = [
        { label: "ตรวจสอบแล้วให้จัดซ่อมได้", value: "Y" },
        { label: "ตรวจแล้วยังไม่ให้จัดซ่อม", value: "N" },

    ];

    const feedBackResultOptions = [
        { label: "ตรวจแล้วผ่าน", value: "Y" },
        { label: "ตรวจแล้วให้แก้ไข", value: "N" },

    ];
    return (
        <div>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-12">
                    <h5 className="p-no-box line-under">
                        <b>การตรวจสอบงานซ่อมคืนสภาพ หน่วยงานเจ้าของพื้นที่</b>
                    </h5>
                </div>
                <div className="p-col-12 p-md-6">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="p-field-radiobutton">- การทดสอบวัสดุ</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">

                                    <div className="flex justify-content-center">
                                        <SelectButton
                                            id="testingResult"
                                            optionLabel="label"
                                            options={testingResulOptions}
                                            value={data.testingResult}
                                            onChange={(e) => onInputTextChange(e, "testingResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="testingResult_1" name="testingResult" id="testingResult_1" value="Y" key="testingResult_1" checked={data.testingResult === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "testingResult")} />
                                        <label htmlFor="testingResult_1">ผ่าน</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="testingResult_2" name="testingResult" id="testingResult_2" value="N" key="testingResult_2" checked={data.testingResult === "N" ? true : false} onChange={(e) => onInputTextChange(e, "testingResult")} />
                                        <label htmlFor="testingResult_2">แก้ไข</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <div className="p-col-12 p-md-2">
                            {data.testingResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T501")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.testingResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T501")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T501")} /> */}
                        </div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="p-field-radiobutton">- การทดสอบการกดทับวัสดุในสนาม</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <div className="flex justify-content-center">
                                        <SelectButton
                                            id="fieldTestingResult"
                                            optionLabel="label"
                                            options={fieldTestingResultOptions}
                                            value={data.testingResult}
                                            onChange={(e) => onInputTextChange(e, "fieldTestingResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="fieldTestingResult_1" name="fieldTestingResult" id="fieldTestingResult_1" value="Y" key="fieldTestingResult_1" checked={data.fieldTestingResult === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "fieldTestingResult")} />
                                        <label htmlFor="fieldTestingResult_1">ถูกต้อง</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="fieldTestingResult_2" name="fieldTestingResult" id="fieldTestingResult_2" value="N" key="fieldTestingResult_2" checked={data.fieldTestingResult === "N" ? true : false} onChange={(e) => onInputTextChange(e, "fieldTestingResult")} />
                                        <label htmlFor="fieldTestingResult_2">แก้ไข</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.testingResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T502")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.testingResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T502")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T501")} /> */}
                        </div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="p-field-radiobutton">- การแจ้งกำหนดการซ่อม และผลการตรวจสอบของหน่วยงานเจ้าของพื้นที่</label>
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton"></label>
                        </div>
                        <div className="p-col-12 p-md-8">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">

                                <div className="flex justify-content-center">
                                        <SelectButton
                                            id="scheduleInformResult"
                                            optionLabel="label"
                                            options={scheduleInformResultOptions}
                                            value={data.scheduleInformResult}
                                            onChange={(e) => onInputTextChange(e, "scheduleInformResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="scheduleInformResult_1"
                                            name="scheduleInformResult"
                                            id="scheduleInformResult_1"
                                            value="Y"
                                            key="scheduleInformResult_1"
                                            checked={data.scheduleInformResult === "Y" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "scheduleInformResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="scheduleInformResult_1">ตรวจสอบแล้วให้จัดซ่อมได้</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-12">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="scheduleInformResult_2"
                                            name="scheduleInformResult"
                                            id="scheduleInformResult_2"
                                            value="N"
                                            key="scheduleInformResult_2"
                                            checked={data.scheduleInformResult === "N" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "scheduleInformResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="scheduleInformResult_2">ตรวจแล้วยังไม่ให้จัดซ่อม</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="p-field-radiobutton">- แจ้งการจัดซ่อมแล้วเสร็จ และผลการตรวจสอบของหน่วยงานเจ้าของพื้นที่</label>
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton"></label>
                        </div>
                        <div className="p-col-12 p-md-8">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                <div className="flex justify-content-center">
                                        <SelectButton
                                            id="feedBackResult"
                                            optionLabel="label"
                                            options={feedBackResultOptions}
                                            value={data.feedBackResult}
                                            onChange={(e) => onInputTextChange(e, "feedBackResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="feedBackResult_1" name="feedBackResult" id="feedBackResult_1" value="Y" key="feedBackResult_1" checked={data.feedBackResult === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "feedBackResult")} />
                                        <label htmlFor="feedBackResult_1">ตรวจแล้วผ่าน</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-12">
                                    <div className="p-field-radiobutton">
                                        <RadioButton disabled={disabledPage} inputId="feedBackResult_2" name="feedBackResult" id="feedBackResult_2" value="N" key="feedBackResult_2" checked={data.feedBackResult === "N" ? true : false} onChange={(e) => onInputTextChange(e, "feedBackResult")} />
                                        <label htmlFor="feedBackResult_2">ตรวจแล้วให้แก้ไข</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-md-6">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-1">
                            <label htmlFor="p-field-radiobutton">บันทึก</label>
                        </div>
                        <div className="p-col-12 p-md-9">
                            <div className="p-inputgroup">
                                <InputTextarea disabled={disabledPage} value={data.repairNote} rows={14} cols={30} autoResize maxLength="5000" onChange={(e) => onInputTextChange(e, "repairNote")} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
